"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { Challenge } from "./challenge";
import { Solution } from "./solution";
import { Ecosystem } from "./ecosystem";
import { PartnerTiers } from "./partner-tiers";
import { KeyMetrics } from "./key-metrics";
import { PartnershipModels } from "./partnership-models";
import { TechnologyPartners } from "./technology-partners";
import { StrategicAlliances } from "./strategic-alliances";
import { ChannelPartners } from "./channel-partners";
import { ConsultingPartners } from "./consulting-partners";
import { PartnerBenefits } from "./partner-benefits";
import { PartnerEnablement } from "./partner-enablement";
import { PartnerSuccess } from "./partner-success";
import { WhyPartner } from "./why-partner";
import { PartnerCta } from "./cta";
import { ContactInfo } from "./contact-info";

export function PartnersPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <ExecutiveSummary />
      </div>
      <Challenge />
      <div className="bg-aurora-emerald">
        <Solution />
      </div>
      <Ecosystem />
      <div className="bg-aurora-cyan">
        <PartnerTiers />
      </div>
      <KeyMetrics />
      <div className="bg-aurora-amber">
        <PartnershipModels />
      </div>
      <TechnologyPartners />
      <div className="bg-aurora-crimson">
        <StrategicAlliances />
      </div>
      <ChannelPartners />
      <div className="bg-aurora-purple">
        <ConsultingPartners />
      </div>
      <PartnerBenefits />
      <div className="bg-aurora-emerald">
        <PartnerEnablement />
      </div>
      <PartnerSuccess />
      <div className="bg-aurora-cyan">
        <WhyPartner />
      </div>
      <PartnerCta />
      <ContactInfo />
    </>
  );
}
